import React, { useEffect, useRef, useState } from "react";
import ROUTE_PATH from "../../constant/route";
import { useNavigate } from "react-router-dom";
import BackArrow from "../../assets/svg/back-arrow.svg";
import PrimaryButton from "../../components/Button/PrimaryButton";
import TextInput from "../../components/TextInput";
import { useFormik } from "formik";
import { validationSchemaSupport } from "../../utils/validation/customerFormValidation";
import { InputAdornment } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../store/store";
import { handleSupport } from "../../store/reducers/support/apiThunk";
import { showToast } from "../../components/Toast";
// import ReCAPTCHA from "react-google-recaptcha";

const SupportMobile = () => {
  const dispatch = useDispatch<AppDispatch>();
  const userData = useSelector((state: any) => state?.authentication?.userData);
  console.log('userData', userData)
  // const recaptchaRef = useRef<ReCAPTCHA | null>(null);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: {
      name: `${userData[0]?.firstName} ${userData[0]?.lastName}` || "",
      email: `${userData[0]?.email}` || "",
      query: "",
      company: "",
      phoneNumber: `${userData[0]?.mobileNo}` || "",
      captchaResponse: null,
    },
    validationSchema: validationSchemaSupport,
    onSubmit: async (values: any) => {
      const data = {
        fullName: values?.name,
        email: values?.email,
        message: values?.query,
        company: values?.company,
        phoneNumber: values?.phoneNumber,
        captchaResponse: values?.captchaResponse,
        source: "Partner",
        partnerName: "Prosure",
      }
      console.log(values);
      const response: any = await dispatch(handleSupport(data));
      if(response?.payload?.status === 1){
        navigate(-1);
        showToast("Message sent successfully", "success");
      }else{
        showToast("Something went wrong", "error")
      }
    },
  });
  useEffect(() => {
    // Function to update window width
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    // Add event listener to update width on window resize
    window.addEventListener("resize", handleResize);

    // Cleanup function to remove event listener
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (windowWidth > 600) {
      navigate(ROUTE_PATH.WELLNESS);
    }
  }, [windowWidth]);
  // const siteKey = "6Lcq1P0lAAAAADdADCc-QBpBn-Z-pNrRp_hiWMrC";
  return (
    <div className="py-[30px] px-[16px]">
      <div className="flex items-center w-[100%] text-[16px] leading-[20px] font-semibold">
        <img
          src={BackArrow}
          alt="BackArrow"
          className="block lg:hidden relative left-[-5%]"
          onClick={() => navigate(ROUTE_PATH.DASHBOARD)}
        />
        <span className="relative top-[-5px] left-[-5%]">Need Assistance?</span>
      </div>
      <div className="flex flex-col justify-between h-[80vh]">
        <div>
          <div className="text-[10px] leading-[16px] font-medium text-text-color-3 pt-[5px] font-poppins">
            Fill out the form below, and we’ll get back to you as soon as
            possible.
          </div>
          <form onSubmit={formik.handleSubmit} className="w-[100%]">
            <div className="w-[100%] mt-[30px] grid gap-4">
              <TextInput
                name="name"
                value={formik.values.name}
                disabled
                onChange={(e: any) => {
                  const value = e.target.value;
                  const regex = /^[A-Za-z.\s]*$/; // Allows alphabets, spaces, and periods
                  if (value === "" || regex.test(value)) {
                    formik.setFieldValue("name", value);
                  }
                }}
                onBlur={formik.handleBlur}
                error={formik.touched.name && Boolean(formik.errors.name)}
                helperText={formik.touched.name && formik.errors.name}
                inputProps={{
                  placeholder: "Enter your name",
                  maxLength: 40,
                }}
              />
              <TextInput
                name="email"
                type="email"
                fullWidth
                disabled
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
                inputProps={{ placeholder: "Enter your email" }}
              />
              <TextInput
                name="phoneNumber"
                fullWidth
                disabled
                value={formik.values.phoneNumber}
                onChange={(e: any) => {
                  const value = e.target.value;
                  const regex = /^[0-9]*$/;
                  if (value === "" || regex.test(value)) {
                    formik.setFieldValue("phoneNumber", value);
                  }
                }}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.phoneNumber &&
                  Boolean(formik.errors.phoneNumber)
                }
                helperText={
                  formik.touched.phoneNumber && formik.errors.phoneNumber
                }
                inputProps={{
                  placeholder: "Enter you phone number",
                  maxLength: 10,
                }}
                slotProps={{
                  input: {
                    startAdornment: (
                      <InputAdornment
                        style={{
                          borderRight: "1px solid #070C1A33",
                          margin: "0",
                          paddingRight: "8px",
                        }}
                        position="start"
                      >
                        +91
                      </InputAdornment>
                    ),
                  },
                }}
              />
              <TextInput
                name="query"
                fullWidth
                value={formik.values.query}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.query && Boolean(formik.errors.query)}
                helperText={formik.touched.query && formik.errors.query}
                inputProps={{ placeholder: "Write your query..." }}
                row={2}
                sx={{
                  div: {
                    padding: 0,
                  },
                }}
                multiline={true}
              />
              {/* <div>
                <ReCAPTCHA
                  ref={recaptchaRef}
                  sitekey={siteKey}
                  onChange={(value: any) =>
                    formik.setFieldValue("captchaResponse", value)
                  }
                  className="my-[10px]"
                />
                {formik.touched.email && Boolean(formik.errors.email) && (
                  <div className="text-text-color-8 text-[0.75rem] leading-[1.66] mx-[14px]">
                    {formik.touched.captchaResponse &&
                      formik.errors.captchaResponse}
                  </div>
                )}
              </div> */}
            </div>
            <div className="flex items-center justify-between w-[100%]">
              <PrimaryButton
                label={
                  <div className="flex items-center justify-center w-[100%] font-black">
                    <div className="text-[14px] leading-[18px] lg:text-[18px] lg:leading-[18px] text-text-color-3">
                      Cancel
                    </div>
                  </div>
                }
                onClick={() => {
                  formik.resetForm();
                  navigate(-1);
                }}
                classname="w-[45%] mx-auto mt-[20px] lg:mt-[40px]"
                style={{ backgroundColor: "#E5E5E5" }}
              />
              <PrimaryButton
                label={
                  <div className="flex items-center justify-center w-[100%] font-black">
                    <div className="text-[14px] leading-[18px] lg:text-[18px] lg:leading-[18px] ">
                      Submit
                    </div>
                  </div>
                }
                type="submit"
                classname="w-[45%] mx-auto mt-[20px] lg:mt-[40px]"
              />
            </div>
          </form>
        </div>
        <div>
          <div className="text-center mt-[30px] text-[14px] leading-[18px] font-semibold">
            <a
              href="mailto:care@coversure.in"
              style={{
                cursor: "pointer",
              }}
            >
              support@coversure.in
            </a>
          </div>
          <div className="text-center mt-[10px] text-[14px] leading-[18px] font-semibold mt-[10px]">
            <a
              href="tel:02238431000"
              style={{
                cursor: "pointer",
              }}
            >
              022-38431000
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupportMobile;
